import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const containerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  minHeight: '50vh',
  gap: 2,
} as const;

export const Loader = () => {
  const { t } = useTranslation();
  return (
    <Box sx={containerStyles}>
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        {t('common.loading')}
      </Typography>
    </Box>
  );
};
